<template>
  <main class="container mt-5">
    <h1 class="text-center">{{schoolName}}</h1>
    <div class="row">
      <div class="col-sm-4 box text-center">
        <div>
          <span>Total de Estudiantes</span>
          <h1 class="display-3">
            <i class="fas fa-user-graduate"></i>
            {{students.length|| 0}}
          </h1>
        </div>
      </div>

      <div class="col-sm-4 box text-center">
        <div>
          <span>Total de Grupos Registrados</span>
          <h1 class="display-3">
            <i class="fas fa-users"></i>
            {{groups.length || 0}}
          </h1>
        </div>
      </div>

      <div class="col-sm-4 box text-center">
        <div>
          <span>Estudiantes Registrados Hoy</span>
          <h1 class="display-3">
            <i class="fas fa-school"></i>
            {{attendance.length || 0}}
          </h1>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <chart @error="chartError()"/>
      </div>
    </div>
  </main>
</template>

<script>
import Chart from "@/components/Chart";
export default {
  components: { Chart },
  data() {
    return {
      url: this.$store.state.url,
      schoolId: this.$store.state.schoolId,
      schoolName: this.$store.state.schoolName,
      students: 0,
      groups: 0,
      attendance: 0
    };
  },
  mounted() {    
    this.getStudets();
    this.getGroups();
    this.getTodayAttendance();
  },
  methods: {
    async getStudets() {
      let req = await fetch(this.url + "students/" + this.schoolId);
      this.students = await req.json();
      this.$store.commit("setStudents",this.students);
    },
    async getGroups() {
      let req = await fetch(this.url + "groups/" + this.schoolId);
      this.groups = await req.json();
    },
    async getTodayAttendance() {
      let date = this.parseDate(new Date());
      let req = await fetch(
        this.url + "getTodayAttendance/" + this.schoolId + "/" + date
      );
      this.attendance = await req.json();
    },
    parseDate(value) {
      let d = value.getDate();
      if (d < 10) {
        d = "0" + d;
      }
      let m = value.getMonth() + 1;
      if (m < 10) {
        m = "0" + m;
      }
      let y = value.getFullYear();
      return y + "-" + m + "-" + d;
    },
    chartError(){
      console.warn("######### por pago")
      localStorage.clear()
      this.$router.push('/login')
    }
  }
};
</script>

<style>
.box div {
  border: solid 1px #fff;
  padding: 1rem;
  border-radius: 10px;
  color: #fff;
  box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.3);
  margin: 1rem;
}
</style>